import { useEffect } from 'react'

export const useDebounceEffect = (cb: () => void, time: number) => {
  useEffect(() => {
    const timeout = setTimeout(cb, time)

    return () => {
      clearTimeout(timeout)
    }
  }, [cb, time])
}
